export default __webpack_public_path__ + "img/facebook_hover.432c20d3ca9a6115262b03ebd3c6bc78.svg";